import React from 'react'

import InvoiceDetailItemTable from './InvoiceDetailItemTable'
import InvoiceStatus from './InvoiceStatus'
import { TableList } from 'components/Case/CaseDetail/TableList'

export default ({ resource, siItems, caseCurrency }) => {
  return (
    <TableList>
      <div className="block-tree-container">
        <div className="block-tree-main"></div>
        {!!siItems.length &&
          siItems.map((siItem, index) => (
            <div key={index} className="invoice-order-block-purchase col-sm-11 offset-sm-1 d-flex flex-wrap mb-6">
              <div className="block-tree-item-offset"></div>
              <div className="block-tree-item">&nbsp;</div>
              <InvoiceDetailItemTable resource={resource} siItem={siItem} caseCurrency={caseCurrency} />
              <InvoiceStatus
                resource={resource}
                status={siItem.status}
                pdfFileId={siItem.pdfFileId}
                tiffFileId={siItem.tiffFileId}
                documentNumber={siItem.documentNumber}
                invoiceItem={siItem}
              />
            </div>
          ))}
      </div>
    </TableList>
  )
}
